// Help / user-guide API — talks to the backend /api/v1/help endpoints, which
// serve the Markdown files under docs/USER_GUIDE (single source of truth).

import { ApiService } from '@/utils/api';

export interface HelpSection {
  slug: string;
  order: string;
  title: string;
  group: string;
}

export interface HelpSectionContent {
  slug: string;
  title: string;
  markdown: string;
}

export const helpApi = {
  listSections: () => ApiService.get<{ sections: HelpSection[] }>('/v1/help/sections'),
  getSection: (slug: string) => ApiService.get<HelpSectionContent>(`/v1/help/sections/${slug}`),
};
